import { render, staticRenderFns } from "./InterpreterStatistics.vue?vue&type=template&id=157f8e61&scoped=true&"
import script from "./InterpreterStatistics.vue?vue&type=script&lang=js&"
export * from "./InterpreterStatistics.vue?vue&type=script&lang=js&"
import style0 from "./InterpreterStatistics.vue?vue&type=style&index=0&id=157f8e61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157f8e61",
  null
  
)

export default component.exports